/* global axios */
import ApiClient from './ApiClient';

class SocialPostsAPI extends ApiClient {
  constructor() {
    super('social_posts', { accountScoped: true });
  }

  getByInbox(inboxId, page = 1) {
    return axios.get(this.url, {
      params: { inbox_id: inboxId, page },
    });
  }
}

export default new SocialPostsAPI();
